"use client";

import React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { LayoutDashboard, Users, Bot, Store, Video, Settings, Menu, ChevronLeft, ShieldCheck } from "lucide-react";
import { cn } from "@/lib/utils";

const menuItems = [
  { icon: LayoutDashboard, label: "Dashboard", href: "/" },
  { icon: Users, label: "CRM OtterQ", href: "/crmotterq" },
  { icon: Users, label: "CRM Otter Salt", href: "/crmottersalt" },
  { icon: Users, label: "CRM Nah Hannah", href: "/crmnahhannah" },
  { icon: Bot, label: "Discovery OtterQ", href: "/agentsotterq" },
  { icon: Bot, label: "Discovery Otter Salt", href: "/agentsottersalt" },
  { icon: Bot, label: "Discovery Nah Hannah", href: "/agentsnahhannah" },
  { icon: ShieldCheck, label: "Operations", href: "/operations" },
  { icon: Store, label: "Store / Inventory", href: "/inventory" },
  { icon: Video, label: "Content Hub", href: "/content" },
];

export function Sidebar() {
  const pathname = usePathname();
  const [isCollapsed, setIsCollapsed] = React.useState(false);

  return (
    <div className={cn(
      "relative h-screen bg-slate-900 border-r border-slate-800 transition-all duration-300",
      isCollapsed ? "w-20" : "w-64"
    )}>
      <div className="flex items-center justify-between p-6 h-20 border-b border-slate-800">
        {!isCollapsed && (
          <span className="text-xl font-bold bg-gradient-to-r from-indigo-400 to-violet-400 bg-clip-text text-transparent">
            OtterQ MASTER
          </span>
        )}
        <button 
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="p-1 hover:bg-slate-800 rounded transition-colors text-slate-400"
        >
          {isCollapsed ? <Menu size={20} /> : <ChevronLeft size={20} />}
        </button>
      </div>

      <nav className="mt-8 px-4 space-y-2">
        {menuItems.map((item) => {
          const isActive = pathname === item.href;
          return (
            <Link 
              key={item.href}
              href={item.href}
              className={cn(
                "flex items-center gap-4 px-4 py-3 rounded-lg transition-all group",
                isActive 
                  ? "bg-indigo-600/10 text-indigo-400 border border-indigo-600/20" 
                  : "text-slate-400 hover:bg-slate-800 hover:text-slate-100"
              )}
            >
              <item.icon size={20} className={cn(
                "transition-colors",
                isActive ? "text-indigo-400" : "group-hover:text-slate-100"
              )} />
              {!isCollapsed && <span className="font-medium">{item.label}</span>}
            </Link>
          );
        })}
      </nav>

      <div className="absolute bottom-4 left-0 w-full px-4">
        <Link 
          href="/settings"
          className={cn(
            "flex items-center gap-4 px-4 py-3 rounded-lg text-slate-400 hover:bg-slate-800 transition-all",
            isCollapsed && "justify-center"
          )}
        >
          <Settings size={20} />
          {!isCollapsed && <span className="font-medium">Settings</span>}
        </Link>
      </div>
    </div>
  );
}
